import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';

@Component({
  selector: 'app-addtocart-popup-confirmation',
  templateUrl: './addtocart-popup-confirmation.component.html',
  styleUrls: ['./addtocart-popup-confirmation.component.scss'],
  standalone: false
})
export class AddtocartPopupConfirmationComponent {
  fleetPrideGroup: any;
  showNetPrice$ = this.custIDService.showNetPrice$;
  showListPrice$ = this.custIDService.showListPrice$;
  subscription = new Subscription();
  constructor(@Inject(MAT_DIALOG_DATA) public _data: { cartData: any },
    private custIDService: CustomerIdService, private cdr: ChangeDetectorRef,) { }
  ngOnInit() {
    this.subscription.add(this.custIDService.fleetPrideGroup$.subscribe(x => {
      this.fleetPrideGroup = x;
      console.log("fleetPrideGroup", this.fleetPrideGroup);
      this.cdr.detectChanges();
    }));
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
